"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Text_1 = require("../Text");
const styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
const commonStyles = (0, styled_components_1.css) `
  cursor: pointer;
  text-decoration: none;
  :hover,
  :active,
  :focus {
    text-decoration: underline;
  }
`;
const ButtonLink = (0, styled_components_1.default)('button') `
  /* resets button styles */
  padding: 0;
  border: none;
  font: inherit;
  color: ${({ $color }) => $color};
  background-color: transparent;
  text-align: inherit;

  ${commonStyles}
`;
const A = (0, styled_components_1.default)('a') `
  color: ${({ $color }) => $color};

  ${commonStyles}
`;
const StyledRouterLink = (0, styled_components_1.default)(react_router_dom_1.Link) `
  color: ${({ color }) => color};

  ${commonStyles}
`;
class Link extends React.PureComponent {
    render() {
        const _a = this.props, { href, to, onClick, children, target, theme, primary, danger, success, warning, faded } = _a, restProps = tslib_1.__rest(_a, ["href", "to", "onClick", "children", "target", "theme", "primary", "danger", "success", "warning", "faded"]);
        const color = (0, Text_1.getColorFromProps)(theme, this.props);
        if (href) {
            return (React.createElement(A, Object.assign({ href: href, "$color": color }, (!!target && { target }), { onClick: onClick }, restProps), children));
        }
        if (to) {
            return (React.createElement(StyledRouterLink, Object.assign({ to: to, color: color, onClick: onClick }, restProps), children));
        }
        return (React.createElement(ButtonLink, Object.assign({ type: "button", "$color": color, onClick: onClick }, restProps), children));
    }
}
Link.defaultProps = {
    className: '',
    children: null,
    primary: false,
    danger: false,
    success: false,
    warning: false,
    faded: false,
};
exports.default = (0, styled_components_1.withTheme)(Link);
